import { ButtonWidthTypeToken, GradientColorTokens, InputStateToken, InputTypeToken, KeyboardTypeToken, SizeTypeTokens, StackAlignContent, StackAlignItems, StackFlexWrap, StackHeight, StackJustifyContent, StackType, StackWidth, WIDGET, } from '@voltmoney/schema';
export const args = {
    type: StackType.row,
    // alignSelf: StackSelfContent.baseline,
    alignContent: StackAlignContent.flexEnd,
    height: StackHeight.MATCH_PARENT,
    width: StackWidth.MATCH_PARENT,
    gradient: {
        colors: GradientColorTokens.D_10,
        start: {
            x: 0,
            y: 100,
        },
    },
    // borderConfig: {
    // 	borderRadius: BorderRadiusTokens.BR3,
    // 	borderWidth: {
    // 		all: SizeTypeTokens.Size6,
    // 	},
    // 	borderColor: ColorTokens.Orange_200
    // },
    //position: StackPositionType.relative,
    positionConfig: {
        top: SizeTypeTokens.Size80,
        bottom: SizeTypeTokens.Size30,
    },
    padding: {
        top: SizeTypeTokens.Size10,
        left: SizeTypeTokens.Size32,
        right: SizeTypeTokens.Size32,
        bottom: SizeTypeTokens.Size30,
    },
    flexWrap: StackFlexWrap.wrap,
    children: [
    /*<View
        style={{
            backgroundColor: '#000',
            height: 50,
            width: 100,
        }}
    />,*/
    ],
    widgetItems: [
        {
            id: 'button',
            type: WIDGET.BUTTON,
            props: {
                label: 'hello stack',
                width: ButtonWidthTypeToken.CONTENT,
            },
        },
        {
            id: 'input',
            type: WIDGET.INPUT,
            props: {
                isFocus: true,
                clearEnabled: false,
                type: InputTypeToken.DEFAULT,
                width: StackWidth.CONTENT,
                state: InputStateToken.DEFAULT,
                title: 'Name',
                placeholder: 'Enter your name',
                keyboardType: KeyboardTypeToken.default,
            },
        },
        {
            id: 'button',
            type: WIDGET.BUTTON,
            props: {
                label: 'hello stack',
                width: ButtonWidthTypeToken.CONTENT,
            },
        },
        {
            id: 'button',
            type: WIDGET.BUTTON,
            props: {
                label: 'hello stack',
                width: ButtonWidthTypeToken.CONTENT,
            },
        },
        {
            id: 'button',
            type: WIDGET.BUTTON,
            props: {
                label: 'hello stack',
                width: ButtonWidthTypeToken.CONTENT,
            },
        },
        {
            id: 'button',
            type: WIDGET.BUTTON,
            props: {
                label: 'hello stack',
                width: ButtonWidthTypeToken.CONTENT,
            },
        },
        {
            id: 'button',
            type: WIDGET.BUTTON,
            props: {
                label: 'hello stack',
                width: ButtonWidthTypeToken.CONTENT,
            },
        },
        {
            id: 'button',
            type: WIDGET.BUTTON,
            props: {
                label: 'hello stack',
                width: ButtonWidthTypeToken.CONTENT,
            },
        },
        {
            id: 'button',
            type: WIDGET.BUTTON,
            props: {
                label: 'hello stack',
                width: ButtonWidthTypeToken.CONTENT,
            },
        },
    ],
};
export const argTypes = {
    type: {
        control: 'select',
        options: [...Object.values(StackType)],
    },
    justifyContent: {
        control: 'select',
        options: [
            ...Object.values(StackJustifyContent),
        ],
    },
    alignItems: {
        control: 'select',
        options: [...Object.values(StackAlignItems)],
    },
    width: {
        control: 'select',
        options: [...Object.values(StackWidth)],
    },
    height: {
        control: 'select',
        options: [...Object.values(StackHeight)],
    },
};
